import { render, staticRenderFns } from "./ProjectImageSwiper.vue?vue&type=template&id=4fea8d19&scoped=true&"
import script from "./ProjectImageSwiper.vue?vue&type=script&lang=js&"
export * from "./ProjectImageSwiper.vue?vue&type=script&lang=js&"
import style0 from "./ProjectImageSwiper.vue?vue&type=style&index=0&id=4fea8d19&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea8d19",
  null
  
)

export default component.exports